import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { FotoArticulo } from "../../../FotoArticulo";

// Fotos de los modelos de un pedido: un renglon por modelo (articulo + renglon
// del pedido) con sus dos fotos —la del modelo (la que sale en el PDF del
// pedido, en el de la orden de compra y en los Excel) y la de fit— y su boton
// para subir cada una. Las fotos son del articulo: si el mismo modelo va en dos
// renglones, comparten fotos.
const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });
const num = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);

function FotosPedidoModal({ abierto, cerrar, pedido }) {
  const [modelos, setModelos] = useState([]);

  useEffect(() => {
    if (!abierto || !pedido) return;
    setModelos([]);
    axios.get(`${process.env.REACT_APP_URL_ARTICULOS_PEDIDO}/pedidos/${pedido._id}`, { headers: headers() })
      .then((r) => {
        const porModelo = new Map();
        (r.data || []).filter((a) => a.articulos?.[0] && a.is_active !== "No").forEach((a) => {
          const art = a.articulos[0];
          const k = `${art._id}|${a.renglon || 1}`;
          if (!porModelo.has(k)) {
            porModelo.set(k, {
              key: k, renglon: a.renglon || 1, idArticulo: String(art._id),
              codigo: art.codigo, nombre: art.nombre, urlFoto: art.urlFoto || "", urlFotoFit: art.urlFotoFit || "",
              colores: new Set(), piezas: 0,
            });
          }
          const m = porModelo.get(k);
          m.piezas += Number(a.cantidad) || 0;
          if (a.colores?.[0]?.name) m.colores.add(a.colores[0].name);
        });
        setModelos([...porModelo.values()].sort((a, b) => a.renglon - b.renglon));
      })
      .catch((e) => Swal.fire({ icon: "error", title: "No se pudieron traer los modelos", text: e.message }));
  }, [abierto, pedido]); // eslint-disable-line

  // la foto es del articulo: se actualiza en todos sus renglones
  const actualiza = (idArticulo, campo, url) =>
    setModelos((prev) => prev.map((x) => (x.idArticulo === idArticulo ? { ...x, [campo]: url } : x)));

  const repetidos = modelos.reduce((acc, m) => ({ ...acc, [m.idArticulo]: (acc[m.idArticulo] || 0) + 1 }), {});

  return (
    <Modal size="lg" isOpen={abierto} toggle={cerrar}>
      <ModalHeader toggle={cerrar}>
        Fotos de los modelos · Pedido {pedido?.numero} {pedido?.clientes ? `· ${pedido.clientes}` : ""}
      </ModalHeader>
      <ModalBody>
        <p style={{ color: "#64748b", marginTop: 0, fontSize: 13 }}>
          <b>Foto del modelo</b>: la que sale en el PDF del pedido, en el de la orden de compra y en los Excel.
          <b> Foto de fit</b>: la muestra puesta, para el seguimiento con el proveedor.
        </p>
        <Table size="sm" bordered style={{ marginBottom: 0 }}>
          <thead>
            <tr>
              <th style={{ width: 40 }}>#</th>
              <th>Modelo</th>
              <th style={{ textAlign: "right" }}>Piezas</th>
              <th style={{ width: 120, textAlign: "center" }}>Foto del modelo</th>
              <th style={{ width: 120, textAlign: "center" }}>Foto de fit</th>
            </tr>
          </thead>
          <tbody>
            {!modelos.length ? (
              <tr><td colSpan={5} style={{ textAlign: "center", color: "#94a3b8" }}>Cargando...</td></tr>
            ) : modelos.map((m) => (
              <tr key={m.key}>
                <td style={{ color: "#94a3b8", verticalAlign: "middle" }}>{m.renglon}</td>
                <td style={{ verticalAlign: "middle" }}>
                  <b>{m.codigo}</b> {m.nombre}
                  <div style={{ fontSize: 12, color: "#64748b" }}>{[...m.colores].join(" · ")}</div>
                  {repetidos[m.idArticulo] > 1 ? (
                    <div style={{ fontSize: 11, color: "#b45309" }}>El mismo modelo va en otro renglón: comparten fotos</div>
                  ) : null}
                </td>
                <td style={{ textAlign: "right", verticalAlign: "middle" }}>{num(m.piezas)}</td>
                <td style={{ textAlign: "center" }}>
                  <FotoArticulo idArticulo={m.idArticulo} url={m.urlFoto} tipo="modelo"
                    onSubida={(url) => actualiza(m.idArticulo, "urlFoto", url)} />
                </td>
                <td style={{ textAlign: "center" }}>
                  <FotoArticulo idArticulo={m.idArticulo} url={m.urlFotoFit} tipo="fit"
                    onSubida={(url) => actualiza(m.idArticulo, "urlFotoFit", url)} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={cerrar}>Cerrar</Button>
      </ModalFooter>
    </Modal>
  );
}

export default FotosPedidoModal;
